// local dependencies
import { messageBus } from 'core/modules/message-bus';
import * as MESSAGE_BUS_EVENTS from 'constants/message-bus-events';

// default overlay payload
const DEFAULT_PAYLOAD = {
    element: {},
    title: undefined,
    text: undefined,
};

/**
 * @desc Open tooltip.
 * @example
 * import { tooltip } from 'modules/tooltip';
 * tooltip.open( { element, title, text } );
 */
export const open = ( payload = {} ) => {
    messageBus.trigger( MESSAGE_BUS_EVENTS.OPEN_TOOLTIP, {
        ...DEFAULT_PAYLOAD,
        ...payload,
    } );
};

/**
 * @desc Close tooltip.
 *  * @example
 * import { tooltip } from 'modules/tooltip';
 * tooltip.close();
 */
export const close = () => {
    messageBus.trigger( MESSAGE_BUS_EVENTS.CLOSE_TOOLTIP );
};
